import React, { useEffect } from "react";
import { leavesService } from "../../../../api/services/leavesService";
import { useAppSelector } from "../../../../infra/hooks";

interface PropsValue {
  setAllLeaveTypesData: (data: any) => void;
}
const DTOLoanHistoryViewModal = ({ setAllLeaveTypesData }: PropsValue) => {
  const selector = useAppSelector((state) => state.authSlice);

  async function getAllLeaveTypes(companyId: number, empId: number) {
    const respose: any = await leavesService.getCompanyLeaveTypes(companyId, empId);
    if (respose) {
      setAllLeaveTypesData(respose?.data);
    }
  }

  useEffect(() => {
    if (selector) getAllLeaveTypes(selector.company_id, selector.emp_id);
  }, []);

  return <></>;
};

export default DTOLoanHistoryViewModal;
